import React from "react";
import './App.css';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


const MOBILE_QUERY = '(max-width: 640px)';

const isMobileNow = () =>
  typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches;

function HomePage() {

  // On desktop the sidebars are columns, so open is the natural default.
  // On mobile they're fixed drawers — open would cover the whole page.
  const [isMobile, setIsMobile] = useState(isMobileNow);
  const [leftOpen, setLeftOpen] = useState(() => !isMobileNow());
  const [rightOpen, setRightOpen] = useState(() => !isMobileNow());
  const [fortune, setFortune] = useState('');

  const [hits, setHits] = useState(null);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => {
      setIsMobile(e.matches);
      // entering mobile: tuck the drawers away; leaving it: show the columns
      setLeftOpen(!e.matches);
      setRightOpen(!e.matches);
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  useEffect(() => {
    const fortunes = [
      "THERE'S NO PLACE LIKE 127.0.0.1.",
      "IT WORKS ON MY MACHINE.",
      "Optimization is the root of all evil",
      "REAL PROGRAMMERS COUNT FROM ZERO.",
    ];
    setFortune(fortunes[Math.floor(Math.random() * fortunes.length)]);
  }, []);

  useEffect(() => {
    // [] matters: without it this effect reruns after every render, and it
    // calls setHits — which causes a render. That's an infinite POST loop.
    fetch("/api/hits", { method: "POST" })
      .then((r) => r.json())
      .then((d) => setHits(d.views))
      .catch(() => setHits(null));
  }, [])

  return (
    
      <div className="site-shell">

          <aside className={`sidebar sidebar-left ${leftOpen ? '' : 'collapsed'}`}>
            <button
              className="sidebar-toggle sidebar-toggle-left"
              onClick={() => setLeftOpen(o => !o)}
              aria-label={leftOpen ? 'Collapse left sidebar' : 'Expand left sidebar'}
            >
              {leftOpen ? '◀' : '▶'}
            </button>
            <div className="sidebar-content">
              <p>Links</p>
              <a href="https://youtu.be/erT2A6ZxQow?si=Fx-aMf-rtds-n5Zy" target="_blank" rel="noreferrer">MUSIC</a>
              <a href="https://example.com" target="_blank" rel="noreferrer">SITE TWO</a>
              <a href="https://example.com" target="_blank" rel="noreferrer">SITE THREE</a>
            </div>
          </aside>

          {isMobile && (leftOpen || rightOpen) && (
            <div
              className="sidebar-backdrop"
              onClick={() => { setLeftOpen(false); setRightOpen(false); }}
            />
          )}

          <div className="page">
            <div className="top-bar">
              <span className="hit-counter">WEBSITE HITS: 
                <span>{hits ?? ".."}</span>
              </span>
            </div>

            <header>
              <h1>KEENA SWANSON</h1>
              <p className="subtitle">STUDENT. SOFTWARE DEVELOPER</p>
            </header>

            <hr className="divider" />

            <section>
              <p className="section-label">FORTUNE OF THE DAY:</p>
              <div className="fortune-box">
                "{fortune || '...'}"
              </div>  
            </section>

            <hr className="divider" />

            <section>
              <p className="secton-label">PROJECTS:</p>
              <ul>
                <li>RUST REST API <span className="muted">(SERVES MY FORTUNES)</span></li>
                <li>STUDY BROWSER EXTENSION</li>
                <li>TASK LIST SHELL SCRIPT <span className="muted">(CONNECTED TO THE GOOGLE CALENDAR API)</span></li>
                <li>GEMINI PROMPT ENGINEERING EXTENSION <span className="muted">(LOCAL-FIRST)</span></li>
              </ul>
            </section>

            <section>
              <p className="secton-label">INITIATIVES:</p>
              <ul className="tag-list">
                {['LIGHTNING TALKS', 'SMALL BUSINESS WEBSITE WORKSHOP'].map(item => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </section>

            <section>
              <p className="section-label">LANGUAGES:</p>
              <ul className="initiatives-list">
                {['C++', 'JAVASCRIPT / TYPESCRIPT', 'PYTHON', 'HTML/CSS', 'RUST'].map(lang => (
                  <li key={lang}>{lang}</li>
                ))}
              </ul>
            </section>

            <section>
              <p className="section-label">INTERESTS / HOBBIES:</p>
              <ul>
                {['HOCKEY', 'ART / 3D GRAPHICS', 'NETWORKS', 'VIDEO GAMES', 'SEWING'].map(item => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </section>

            <footer>
              <p>MADE BY KEENA!!!!!! &nbsp; Yes tracking&nbsp; Maybe cookies&nbsp; SITE UNDER CONSTRUCTION&nbsp;</p>
            </footer>
          </div>

          <aside className={`sidebar sidebar-right ${rightOpen ? '' : 'collapsed'}`}>
            <button
              className="sidebar-toggle sidebar-toggle-right"
              onClick={() => setRightOpen(o => !o)}
              aria-label={rightOpen ? 'Collapse right sidebar' : 'Expand right sidebar'}
            >
              {rightOpen ? '▶' : '◀'}
            </button>
            <div className="sidebar-content">
              <p>Blog</p>
                <Link to="/blog/why-start-an-initiative">WHY START AN INITIATIVE?</Link>
                <Link to="/blog/the-glassworm">THE GLASSWORM!</Link>
                <Link to="/blog/task-for-bash">KEENA'S FIRST TASK MANAGER</Link>
            </div>
          </aside>
        </div>
  );
}

export default HomePage;
